import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";

export type WizardSelectOption = { value: string; label: string };

type WizardSelectProps = {
  value: string;
  onValueChange: (value: string) => void;
  options: WizardSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  invalid?: boolean;
  /** Shorter text rendered in the closed trigger; options keep their full labels in the dropdown. */
  selectedLabel?: string;
  "aria-label": string;
  "aria-describedby"?: string;
};

/**
 * The app's shared Radix Select (the one used on the Account page), sized for
 * the wizard's 44px control row. An empty value shows the placeholder.
 * Each item carries `data-option-value` so tests can pick by canonical value.
 */
export default function WizardSelect({
  value,
  onValueChange,
  options,
  placeholder,
  disabled,
  invalid,
  selectedLabel,
  "aria-label": ariaLabel,
  "aria-describedby": describedBy,
}: WizardSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger
        className="w-full min-w-0 text-sm data-[size=default]:h-11 [&_[data-slot=select-value]]:block [&_[data-slot=select-value]]:min-w-0 [&_[data-slot=select-value]]:truncate"
        aria-label={ariaLabel}
        aria-describedby={describedBy}
        aria-invalid={invalid || undefined}
      >
        <SelectValue placeholder={placeholder}>{selectedLabel}</SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value} data-option-value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
